import ReactApexChart from 'react-apexcharts'

const ColumnChart = ({
  noOfClaims,
  totalClaimAmount,
  height,
  colors,
  xAxisLabels,
}) => {
  const options = {
    dataLabels: {
      enabled: false,
    },
    series: [
      {
        name: 'No. Of Claims',
        data: noOfClaims,
      },
      {
        name: 'Total Claim Amnt',
        data: totalClaimAmount,
      },
    ],
    colors: colors,
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: xAxisLabels,
    },
    chart: {
      type: 'bar',
      height: 550,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },
    // yaxis: {
    //   title: {
    //     text: "$ (thousands)",
    //   },
    // },
    fill: {
      opacity: 1,
    },
    legend: {
      show: true,
      position: 'bottom',
      style: {
        colors: '#333333',
        fontSize: '11px',
        fontWeight: 400,
      },
    },
  }
  return (
    <>
      {noOfClaims?.length > 0 ? (
        <ReactApexChart
          options={options}
          series={options?.series}
          type='bar'
          height={height}
        />
      ) : (
        <p>Nil Claims</p>
      )}
    </>
  )
}

export default ColumnChart
